var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGanharNumeros(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.148 12.7c.229 0 .438.13.54.334l2.332 4.708 5.218.755a.598.598 0 01.334 1.022l-3.776 3.666.891 5.175a.598.598 0 01-.24.586.604.604 0 01-.633.045l-4.666-2.443-4.667 2.443a.604.604 0 01-.633-.045.598.598 0 01-.24-.586l.892-5.175-3.775-3.665a.598.598 0 01.333-1.023l5.217-.755 2.333-4.708a.602.602 0 01.54-.334zm0 1.954l-1.934 3.901a.602.602 0 01-.453.328l-4.323.626 3.128 3.037a.597.597 0 01.173.53l-.738 4.29 3.867-2.025a.604.604 0 01.56 0l3.867 2.024-.739-4.288a.598.598 0 01.173-.53l3.129-3.038-4.324-.626a.602.602 0 01-.453-.328l-1.933-3.902z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.043,
    y: 1.2,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#fff"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/ganhar-numeros-349ca387fa1d993f6910fdf15df87901.svg";
export { SvgGanharNumeros as ReactComponent };